// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"styles":"4fda2b8f9168145d185e","default":"179f264a779f1cc3b59d","dark":"d3c69681fcb8c3d12dd9"}[chunkId] + ".css";
};